// extracted by mini-css-extract-plugin
export default {"forgotPasswordLink":"auth_forgotPasswordLink__BGrQU"};